var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"color":"green","small":"","loading":_vm.downloadLoading},on:{"click":_vm.download}},[_vm._v(" "+_vm._s(_vm._f("t")('action.download'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }